import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";

export const GROUP_USER_RESOURCE = "group" as const;
export const GROUP_USER_OPERATION = "user" as const;
export const GROUP_USER_API_PATH = `/v1/${GROUP_USER_RESOURCE}/{uuid}/${GROUP_USER_OPERATION}` as const;

export type GroupUserResponse =
  paths[typeof GROUP_USER_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export const useGroupUserQuery = (uuid: string) =>
  useQuery({
    enabled: !!uuid,
    queryKey: [GROUP_USER_RESOURCE, uuid, GROUP_USER_OPERATION],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<GroupUserResponse>(
        `/v1/${GROUP_USER_RESOURCE}/${uuid}/${GROUP_USER_OPERATION}`,
      );

      return response.data;
    },
  });
